// Hole-card reveals are presentation state. Any effect that replaces or rewrites a seat's
// hand invalidates both room-wide Go Fish reveals and this viewer's private Peek reveal.
const WHOLE_HAND_MUTATORS = new Set([
  'ONE_MANS_TRASH',
  'GRAND_EXCHANGE',
  'MAGIC_TRICK',
]);

export const mutatedHoleSeatForResolvedPlay = (payload = {}, catalogEntry = null) => {
  if (catalogEntry?.requiresDiscard || WHOLE_HAND_MUTATORS.has(payload.card)) {
    return payload.seat ?? null;
  }
  if (payload.targetSeat != null && String(payload.zone || '').toUpperCase() === 'HOLE'
      && Number.isInteger(Number(payload.targetSeat)) && Number(payload.targetSeat) >= 0) {
    return Number(payload.targetSeat);
  }
  return null;
};
